module.exports = __webpack_public_path__ + "static/media/mobilePhone.a5e22d2d.svg";